import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  dialogSubtitle: {
    margnBottom: 8,
  },
  list: {
    paddingLeft: 0,
    margin: 0,
  },
  orderedList: {
    counterReset: 'terms',
    listStyleType: 'none',
    marginTop: 8,
  },
  orderedListSecondPart: {
    marginTop: 4,
    listStyleType: 'none',
  },
  numberedListElement: {
    counterIncrement: 'terms',
    marginLeft: 0,
    marginBottom: 8,
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 10,
    },
    '&:before': {
      content: `counter(terms) '.'`,
      marginRight: 8,
    },
  },
  letteredListElement: {
    marginLeft: 38,
    paddingBottom: 4,
    listStyleType: 'disc',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 5,
    },
  },
}), {name: 'IkzeExtendedEntrepreneurDepositDialog'});
